<template>
  <div class="modal" :style="{display: value ? 'block' : 'none'}" ref="modal">
    <div class="modal-content">
      <span class="close" @click="showComputed = false">&times;</span>
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { computed, ref } from '@vue/composition-api'

export default {
  name: 'ModalDefault',
  props: ['value'],

  setup (props, { emit }) {
    const modal = ref(null)

    const showComputed = computed({
      get: () => props.show,
      set: (value) => emit('input', value)
    })

    window.addEventListener('click', (event) => {
      if (event.target === modal.value) {
        showComputed.value = false
      }
    })
    return { showComputed, modal }
  }
}
</script>

<style scoped>
.modal {
  display: none;
  position: fixed;
  z-index: 1;
  padding-top: 100px;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgb(0,0,0);
  background-color: rgba(0,0,0,0.4);
}

.modal-content {
  background-color: #fefefe;
  margin: auto;
  padding: 20px;
  border: 1px solid #888;
  width: 80%;
}

.close {
  color: #aaaaaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}
</style>
